import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ITK_CATALOG_PRICELIST_URL } from '../../../config';
import { CategoriesContext } from '../../../App';
import MenuItem from '../new-iek/menu-item';
import Search from './elements/search';

function NewItkSidebar() {
    const { categories } = useContext(CategoriesContext);
    const nav = useNavigate();

    return (
        <div className="catalog-sidebar catalog-sidebar--desktop" onClick={(e) => e.stopPropagation()}>
            <span className="btn btn--back" onClick={() => nav(-1)}>
                <svg
                    className="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M4 12h16M14 6l6 6-6 6" />
                </svg>
                <span className="btn__txt">
                    <span className="edited"> Каталог продукции</span>
                </span>
            </span>
            <div className="catalog-sidebar__menu">
                <Search />
                <ul className="catalog-menu">
                    {/* В ITK категории какого-то хрена завернуты в лишний уровень */}
                    {categories[0]?.children?.map((item) => (
                        <MenuItem key={item.slug} {...item} />
                    ))}
                </ul>
            </div>
            <a className="btn" href={ITK_CATALOG_PRICELIST_URL} download>
                <span className="btn__txt">Прайс-лист</span>
                <svg
                    className="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M4 12h16M14 6l6 6-6 6" />
                </svg>
            </a>
        </div>
    );
}

export default NewItkSidebar;
